import { Route, Routes } from 'react-router-dom';

import SuggestedCategoriesList from './SuggestedCategoriesList';

function SuggestedCategoriesModule() {
  return (
    <Routes>
      <Route path="" element={<SuggestedCategoriesList />} />
    </Routes>
  );
}
export default SuggestedCategoriesModule;
